import { render, staticRenderFns } from "./SetupPayment.vue?vue&type=template&id=0bef8e79&"
import script from "./SetupPayment.vue?vue&type=script&lang=js&"
export * from "./SetupPayment.vue?vue&type=script&lang=js&"
import style0 from "./SetupPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports